import React, { useEffect, useRef, useState } from 'react';
import './textArea.style.scss';
import { __InputProps, __TextAreaRef } from './textArea.interface';
import { Language, ReduxState, TextDirection } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPTextAreaRef extends __TextAreaRef {}

const SLPTextArea: React.ForwardRefRenderFunction<__TextAreaRef, ConnectedProps<typeof connector> & __InputProps> = (
    props: ConnectedProps<typeof connector> & __InputProps,
    ref,
) => {
    const lang = props.lang.utilities;
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const [error, setError] = useState<string>();
    const [active, setActive] = useState<boolean>(false);
    const labelRef = useRef<HTMLLabelElement>(null);
    const immediateValue = useRef(props.defaultValue ? props.defaultValue : '');
    const [value, setValue] = useState<string>(immediateValue.current);
    React.useImperativeHandle(ref, () => ({
        getValue: () => (inputRef.current ? inputRef.current.value : ''),
        getValidation: () => Validation(),
        // setValue,
        setError: (text) => {
            setError(text);
        },
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    function onFocusHandler() {
        setActive(true);
    }
    function onblurHandler() {
        setActive(false);
    }
    function onClickHandler() {
        inputRef.current?.focus();
    }
    function onChangeHandler(e: any) {
        if (!props.isNumber || /^\d+$/.exec(e.target.value) !== null || e.target.value.length === 0) {
            setError(undefined);
            immediateValue.current = e.target.value;
            setValue(immediateValue.current);
            if (props.onChange) props.onChange(immediateValue.current);
        }
    }
    function Validation() {
        let validate = true;
        if (immediateValue.current)
            if (
                (props.length && immediateValue.current.length !== props.length) ||
                (props.maxLength && immediateValue.current.length > props.maxLength) ||
                (props.minLength && immediateValue.current.length < props.minLength)
            )
                validate = false;
        return validate;
    }
    return (
        <div
            onClick={onClickHandler}
            className={`ucheck-SLP-textarea ${value.length ? 'filled' : ''} ${active ? 'active' : ''} ${
                error ? 'error' : ''
            } ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}
        >
            <span className="d-flex">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </span>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className={`input-box ${props.endIcon ? 'has-end-icon' : ''} `}>
                <textarea
                    ref={inputRef}
                    value={value}
                    onFocus={onFocusHandler}
                    onBlur={onblurHandler}
                    onChange={onChangeHandler}
                    className={`${props.isNumber ? 'is-number' : ''}`}
                    style={{ color: props.color }}
                    required={props.required}
                    placeholder={props.formLang === Language.en ? lang.SLPInputPHEn : lang.SLPInputPH}
                />
                {props.endIcon && (
                    <i className="material-icons" style={{ color: props.endIcon.color }}>
                        {props.endIcon.icon}
                    </i>
                )}
            </div>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPTextArea));
